import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getTeamMembers as getTeamMembersFromMonolith,
   GetTeamMembersOptions,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

const getTeamMembersSchema = z.object({
   teamid: z.number(),
   order: z.enum(['ASC', 'DESC']).optional(),
});

export async function getTeamMembers(
   teamid: number,
   options: GetTeamMembersOptions | CommonRequestOptions
) {
   return await getTeamMembersFromMonolith(teamid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { teamid, order } = getTeamMembersSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getTeamMembers(teamid, {
         order,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getTeamMembersFromClient = (
   teamid: number,
   options?: GetTeamMembersOptions
): ReturnType<typeof getTeamMembers> => {
   return bff()
      .post('/teams/getTeamMembers', {
         teamid,
         ...options,
      })
      .then(response => response.data);
};

export type GetTeamMembersErrorCode = 'teams.team_members_not_found';
